<template>
    <div>
        <easyCruds ref="mainTable" :tableInfo="mainTable"
                @mainTableReload="mainTableReload"
                @resrt="resrt"
                @addRow="addRow"
                @editRow="editRow"
                @deleteRows="deleteRows"
                @viewRow="viewRow"
                @beforeEditFunctionName="beforeEditFunctionName"
                >
        </easyCruds>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                mainTable:{
                    buttonSetting:{
                        allowAdd: true,
                        addFunctionName: 'addRow',
                        addButtonArray:[{
                            clickEvent: 'addRow',
                            type:'primary',
                            buttonName:'新增',
                            validate:true
                        }],

                        allowEdit: true,
                        editFunctionName: 'editRow',
                        editButtonArray:[{
                            clickEvent:'editRow',
                            type:'primary',
                            buttonName:'保存编辑',
                            validate: true
                        }],
                        beforeEditFunctionName: 'beforeEditFunctionName',
                        allowDelete: true,
                        deleteFunctionName: 'deleteRows',
                        allowView: true,
                    },
                    header:{
                        title:"问卷类型列表"
                    },
                    table:{
                        loading: false,
                        height: 550,
                        stripe: true,
                        conditionLabelWidth: 'auto',
                        selection: true,
                        index: false, 
                        columns:[
                            {
                                prop:"id",
                                label: '类型代码',
                                // isSearchCondition: true,
                                
                                view:[false,true,false],
                            },
                            {
                                prop:"wjlx",
                                label:"问卷类型",
                                view:[false,true,false],
                                type:"select",
                                dicData:[],
                                type:"select",
                                isSearchCondition: true,

                            },
                            {
                                prop:"createOrgName",
                                label:"创建单位",
                                view:[false,true,false]

                            },
                            {
                                prop:"WJLX",
                                label:"问卷类型",
                                required:true,
                                showInTable: false,
                                view:[true,false,true],
                                showWordLimit:true,
                                maxlength:20
                            }
                        ],
                        tableData:[],
                        paging:{
                            currentPage: 1,
                            pageSizes: [10, 15, 20, 25],
                            pageSize: 10,
                            total: 0
                        },
                        reload: 'mainTableReload',
                        reloadConditions: {},
                        addDefultValue: {}
                    }
                }
            }
        },
        methods: {
            mainTableReload: function(params) {
                console.log(params)
                this.mainTable.table.loading = true
                params = params || {}
                this.mainTable.table.loading = true
                if (!params.pageSize) { params.pageSize = 10 }
                if (!params.pageNum) { params.pageNum = 1 }
                if(params.wjlx){
                    params.id=params.wjlx
                    delete params.wjlx
                }
                this.$http.get('/wjType/query', { 
                    params
                }).then(
                    response => {
                    this.mainTable.table.loading = false
                    if (response.code === 200) {
                        // 成功之后的数据
                        this.mainTable.table.tableData = response.data.records
                        this.mainTable.table.paging.total = response.data.total || response.data.records.length
                        return true
                    } else {
                        this.$message.error(response.msg)
                    }
                    }
                ).catch(
                    error => {
                    this.mainTable.table.loading = false
                    }
                )
                },
                 // 新增
            addRow(row, done, errorDone){
                console.log(row);
                this.$http.post("/wjType/save",null,{params:{
                    wjlx:row.WJLX
                }}).then(res=>{
                    this.mainTableReload(this.$refs.mainTable.getReloadConditions())
                    this.getSelectDate("/wjType/listSelect","itemValue","itemCode","id",{params:{delFlag:1}},"get");
                    done();
                }).catch(error=>{
                    this.$message.error(error.msg)
                    errorDone();
                })
            },
            // 编辑之前
            beforeEditFunctionName(row,type,callback){
                console.log(row);
                console.log(this.mainTable.table)
                // this.mainTable.table.reloadConditions.WJLX=row.wjlx;
                callback({WJLX:row.wjlx});
            },
                // 编辑
            editRow: function(row, done, errorDone, optionType) {
                this.$http.put("/wjType/update",null,{params:{
                    id:row.id,
                    wjlx:row.WJLX
                }}).then(res=>{
                    this.mainTableReload(this.$refs.mainTable.getReloadConditions())
                    this.getSelectDate("/wjType/listSelect","itemValue","itemCode","id",{params:{delFlag:1}},"get");
                })
                done();
            },

            // 删除
            deleteRows:function(deleteList){
                // deleteList=deleteList.map(e=>{
                //     return e.id
                // }).join()
                // this.$http.delete('/wjType/delete',{
                //     params:{id:deleteList}
                // }).then(res=>{
                //     // console.log(res);
                //     this.$message.success('删除成功')
                //     this.mainTableReload(this.$refs.mainTable.getReloadConditions())
                // }).catch(error=>{
                //     this.$message.error(error.msg)
                // })
                  deleteList.forEach(e=>{
                        this.$http.delete('/wjType/delete',{
                            params:{id:e.id}
                        }).then(res=>{
                            // console.log(res);
                            this.$message.success('删除成功')
                            this.mainTableReload(this.$refs.mainTable.getReloadConditions())
                            this.getSelectDate("/wjType/listSelect","itemValue","itemCode","wjlx",{params:{delFlag:0}},"get");

                        }).catch(error=>{
                            this.$message.error(error.msg)
                        })
                })
              
            },

            

                // 搜索下拉框
                getSelectDate(url,label,value,prop,params,method){
                    method=method||"post";
                    params=params||{};
                    let column=this.mainTable.table.columns;    
                    let index = this.findArray(column,prop,'prop');
                    this.$http[method](url,params).then(res=>{
                        // console.log(res);
                        let arrDate=[];
                        res.data.forEach(element=>{
                            arrDate.push({
                                label:element[label],
                                value:element[value]
                            })
                        });
                        column[index].dicData=arrDate;
                        // this.$refs.mainTable.setColumnSeting(prop, 'dicData', arrDate)
                    })            
                },
        },
        mounted() {
            this.mainTableReload({})
            // 问卷类型下拉框
            this.getSelectDate("/wjType/listSelect","itemValue","itemCode","wjlx",{params:{delFlag:0}},"get");
        },
    }
</script>

<style lang="scss" scoped>

</style>